import { useEffect } from 'react';

import type { LeaseActionProps } from '../../../models/Types';
import { useCloneLeaseMutation } from '../../../utils/queries';

function CopyLease({ lease, terminateActiveAction }: LeaseActionProps) {
  const cloneLeaseMutation = useCloneLeaseMutation();

  useEffect(() => {
    cloneLeaseMutation.mutate({ postData: { leaseId: lease.id } });
    terminateActiveAction();
  }, []);

  return null;
}

export default CopyLease;
